import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgParkAndRide = (props) => /* @__PURE__ */ _jsxs("svg", {
	height: 30,
	viewBox: "0 0 30 30",
	width: 30,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		stroke: "currentColor",
		strokeMiterlimit: 10,
		strokeWidth: .5,
		transform: "translate(-1572 -363.15)",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "m1577.195 382.353v-9.2h3.8a2.374 2.374 0 0 1 1.093.253 2.891 2.891 0 0 1 .859.661 3.147 3.147 0 0 1 .569.927 2.813 2.813 0 0 1 .207 1.05 3.128 3.128 0 0 1 -.194 1.1 2.961 2.961 0 0 1 -.543.927 2.718 2.718 0 0 1 -.834.648 2.346 2.346 0 0 1 -1.079.246h-2.973v3.4zm.9-4.2h2.935a1.532 1.532 0 0 0 .73-.175 1.776 1.776 0 0 0 .563-.467 2.2 2.2 0 0 0 .362-.674 2.484 2.484 0 0 0 .129-.8 2.237 2.237 0 0 0 -.549-1.477 1.837 1.837 0 0 0 -.594-.447 1.663 1.663 0 0 0 -.718-.162h-2.853z" }),
			/* @__PURE__ */ _jsx("path", {
				d: "m1596.359 379.952v.724h-1.6v1.745h-.814v-1.745h-1.6v-.724h1.6v-1.745h.814v1.745z",
				transform: "translate(-7.686 -2.562)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m1603.98 382.353v-9.2h3.878a2.377 2.377 0 0 1 1.093.253 2.886 2.886 0 0 1 .859.661 3.028 3.028 0 0 1 .563.927 2.894 2.894 0 0 1 .2 1.05 3.12 3.12 0 0 1 -.149.966 3 3 0 0 1 -.413.829 2.508 2.508 0 0 1 -.64.623 2.257 2.257 0 0 1 -.84.343l2.249 3.552h-1.021l-2.159-3.4h-2.714v3.4zm.905-4.2h3a1.534 1.534 0 0 0 .73-.175 1.745 1.745 0 0 0 .563-.473 2.315 2.315 0 0 0 .362-.674 2.425 2.425 0 0 0 .129-.791 2.246 2.246 0 0 0 -.549-1.465 1.929 1.929 0 0 0 -.595-.454 1.612 1.612 0 0 0 -.717-.168h-2.921z",
				transform: "translate(-13.584)"
			})
		]
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 15,
		cy: 15,
		fill: "none",
		r: 15
	})]
});
export default SvgParkAndRide;
